import React from "react";
import styles from "./styles.module.scss";
import { useAppTranslation } from "../../../../../../i18n/useAppTranslation";
import { InputPassword } from "../../../../../../boxes/InputPassword/InputPassword";

export function OrPasscode({ value, setValue, isDisabled }) {
  const { tAuth: t } = useAppTranslation.Auth({
    keyPrefix: "twoFactor.alternativeOtp",
  });

  return (
    <div>
      <div className={styles.or}>{t("or")}</div>
      <div className={styles.inputWrap}>
        <b className={styles.label}>{t("enterPasscode")}:</b>
        <InputPassword
          size="small"
          value={value}
          onChange={(e) => {
            const val = e.target.value;
            if (!val || (/^\d+$/.test(val) && val.length <= 4)) {
              setValue(val);
            }
          }}
          isDisabled={isDisabled}
          inputClassName={styles.input}
        />
      </div>
    </div>
  );
}
